import { Module } from '@nestjs/common';
import { wareHouseBullQueues } from '../warehouse-bull-queue';
import { WarehouseSampleJobProcessor } from './warehouse-sample-processor';

@Module({
  imports: [...wareHouseBullQueues],
  controllers: [],
  providers: [WarehouseSampleJobProcessor],
  // exports: [...m3IntegrationBullQueue],
})
export class WareHouseSampleModule { }
